/* POLYFILL */
import interObserver from 'intersection-observer';

/* BUBBLES */
import bubblecss from 'bubbles/dist/main.css';
import bubbleCalcul from 'bubbles/dist/main.js';
import bubbleAnim from 'bubbles/dist/anims';

// fichier CSS principal
import './styles/style.scss';

import objectFitImages from 'object-fit-images';

// tag XITI
import '../../../_global/scripts/data-xiti.js';

// plugin de lazyloading
import 'lazysizes';

// js des push produits
import './scripts/push-prods';

IntersectionObserver.prototype.USE_MUTATION_OBSERVER = false;
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.srcAttr = 'data-lazy';
window.lazySizesConfig.expand = 350;

$j(() => {
  objectFitImages();

  $j('.gototop').on('click', (e) => {
    e.preventDefault();
    const scroll = $j(window).scrollTop();
    const wHeight = $j('#container').height();
    const targetTop = 0;

    $j('html, body').animate({
      scrollTop: 0,
    }, Math.max(200, 1500 * Math.abs(targetTop - scroll) / wHeight));
  });

  let isCalculating = false;

  window.oldScroll = window.scrollY;
  $j(window).on('scroll', () => {
    if (!isCalculating) {
      window.requestAnimationFrame(() => {
        isCalculating = false;

        if (window.scrollY < 5) {
          $j('.gototop').removeClass('gototop--show');
        } else if (Math.abs(window.oldScroll - window.scrollY) > 1) {
          if (window.oldScroll > window.scrollY) {
            $j('.gototop').addClass('gototop--show');
          } else {
            $j('.gototop').removeClass('gototop--show');
          }
          window.oldScroll = window.scrollY;
        }
      });
      isCalculating = true;
    }
  });

  if (location.hash && location.hash === '#Top3') {
    console.log('OUI');
    setTimeout(() => {
      $j('iframe.conseils__illu').attr('src', 'https://www.youtube-nocookie.com/embed/ZIieIUHGsGs?autoplay=1&mute=1');
    }, 250);
  }
});
